export default "__VITE_ASSET__Bq4yEZ81__"